import sal from 'sal.js';

let salDefault;

export default {
  init() {
    salDefault = sal({
      selector: '[data-sal]',
      threshold: 0.1,
    });

    window.addEventListener('widthResize', () => {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          setTimeout(() => {
            salDefault && salDefault.update();
          }, 300);
        });
      });
    });
  },

  update() {
    salDefault && salDefault.update();
  },
};
